export enum DonorShieldDirectCategory {
    PendTrans = 4,
    Transplanted = 5,
    AddDonor = 12,
    EditDonor = 13,
    UploadLostWage=14
}